import { c as _c } from "react/compiler-runtime";
import { DropMetadata } from "@/entities/IDrop";
export default function CreateDropMetadataItem(t0) {
  const $ = _c(14);
  const {
    item: t1,
    onMetadataRemove
  } = t0;
  const {
    data_key,
    data_value
  } = t1;
  let t2;
  if ($[0] !== data_key) {
    t2 = <span className="tw-font-bold"> {data_key}</span>;
    $[0] = data_key;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data_value || $[3] !== t2) {
    t3 = <p className="tw-mb-0 tw-max-w-xl tw-text-sm tw-font-medium tw-text-iron-50 tw-truncate">{t2}: {data_value}</p>;
    $[2] = data_value;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data_key || $[6] !== onMetadataRemove) {
    t4 = () => onMetadataRemove(data_key);
    $[5] = data_key;
    $[6] = onMetadataRemove;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-text-red group-hover:tw-scale-110 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <button onClick={t4} aria-label="Remove file" className="tw-group tw-p-1.5 tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-border-0 tw-rounded-full hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out">{t5}</button>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="tw-px-3 tw-py-1 tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-600 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out"><div className="tw-flex tw-items-center tw-gap-x-3"><div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-x-2 tw-truncate">{t3}{t6}</div></div></div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}